<template>
  <div class="editor" :class="[{'vte-edit':editable}, {'vte-grouped':grouped}, {'vte-hidden':hidden}, {'vte-compact':compact}]">
      <vap-label v-if="hidden || (display && !editable)" desc :text="'Kommentar'" style="padding-top: 15px;" />
    <EditorMenuBar v-if="editable" :editor="editor" v-slot="{ commands, isActive }" @input="onInput">
      <div class="menubar">

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" class="vte-icon" 
            style="transform: scale(0.6); margin-top: 2px; margin-left: 5px;">
                <path d="M 22.941406 18.046875 C 22.941406 19.160156 22.707031 20.105469 22.234375 20.875 C 21.765625 21.644531 21.089844 22.253906 20.214844 22.699219 C 19.28125 23.171875 18.210938 23.511719 16.996094 23.707031 C 15.78125 23.902344 15.351563 24 13.707031 24 L 2 24 L 2 22.214844 C 2.320313 22.1875 4.03125 21.796875 4.03125 20.261719 L 4.03125 6.054688 C 4.03125 4.195313 2.320313 3.980469 2 3.929688 L 2 2 L 13.953125 2 C 16.960938 2 17.59375 2.414063 18.925781 3.238281 C 20.261719 4.066406 20.925781 5.285156 20.925781 6.898438 C 20.925781 9.984375 18.457031 11.828125 17.652344 12.015625 L 17.652344 12.308594 C 18.457031 12.390625 22.941406 13.261719 22.941406 18.046875 Z M 15.433594 7.824219 C 15.433594 6.914063 15.089844 6.199219 14.402344 5.691406 C 13.714844 5.175781 12.914063 4.921875 11.539063 4.921875 C 11.34375 4.921875 11.089844 4.929688 10.773438 4.941406 C 10.460938 4.953125 10.1875 4.964844 9.960938 4.96875 L 9.960938 11.070313 L 10.765625 11.070313 C 12.441406 11.070313 13.445313 10.777344 14.242188 10.195313 C 15.035156 9.613281 15.433594 8.824219 15.433594 7.824219 Z M 16.246094 17.476563 C 16.246094 16.308594 15.8125 15.414063 14.9375 14.792969 C 14.066406 14.171875 13.035156 13.859375 11.398438 13.859375 C 11.210938 13.859375 10.960938 13.863281 10.648438 13.878906 C 10.339844 13.890625 10.109375 13.898438 9.960938 13.90625 L 9.960938 21.078125 C 9.960938 21.078125 11.601563 21.078125 12.265625 21.078125 C 13.445313 21.078125 14.402344 20.765625 15.140625 20.136719 C 15.878906 19.503906 16.246094 18.617188 16.246094 17.476563 Z"/>
            </svg>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" class="vte-icon" 
            style="transform: scale(0.6); margin-top: 2px; margin-left: 5px;">
                <path d="M 16.398438 24 L 4.199219 24 L 4.699219 22.101563 C 5 22.101563 5.5 22 6 22 C 6.601563 22 6.898438 21.898438 7.199219 21.800781 C 7.601563 21.601563 7.898438 21.398438 8.101563 21.199219 C 8.300781 20.898438 8.5 20.601563 8.601563 20.199219 L 12.199219 6.101563 C 12.300781 5.699219 12.300781 5.398438 12.199219 5.199219 C 12.101563 4.898438 11.898438 4.699219 11.601563 4.5 C 11.398438 4.398438 11 4.300781 10.601563 4.199219 C 10.101563 4.101563 9.601563 4 9.300781 4 L 9.800781 2 L 22 2 L 21.5 4 C 21.199219 4 20.398438 4.101563 19.898438 4.101563 C 19.398438 4.199219 19 4.199219 18.699219 4.300781 C 18.300781 4.398438 17.898438 4.601563 17.699219 4.898438 C 17.5 5.199219 17.300781 5.5 17.300781 5.898438 L 13.699219 20 C 13.601563 20.398438 13.601563 20.699219 13.699219 21 C 13.800781 21.300781 14 21.5 14.300781 21.601563 C 14.5 21.699219 14.800781 21.800781 15.300781 21.898438 C 15.800781 22 16.601563 22 16.898438 22.101563 Z"/>
            </svg>
        </button>

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
        >
          S
        </button> -->

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" class="vte-icon" 
            style="transform: scale(0.7); margin-top: 3px; margin-left: 5px;">
                <path d="M 6 3 L 6 12.875 C 6 13.902344 6.164063 14.800781 6.5 15.5625 C 6.835938 16.320313 7.324219 16.953125 7.9375 17.46875 C 8.550781 17.984375 9.265625 18.371094 10.125 18.625 C 10.984375 18.878906 11.949219 19 13 19 C 14.050781 19 15.015625 18.878906 15.875 18.625 C 16.734375 18.371094 17.449219 17.984375 18.0625 17.46875 C 18.675781 16.953125 19.164063 16.320313 19.5 15.5625 C 19.835938 14.804688 20 13.902344 20 12.875 L 20 3 L 17 3 L 17 11.96875 C 17 12.503906 16.992188 13.042969 16.9375 13.59375 C 16.882813 14.144531 16.699219 14.65625 16.4375 15.09375 C 16.175781 15.53125 15.785156 15.875 15.25 16.15625 C 14.714844 16.4375 13.972656 16.59375 13 16.59375 C 12.027344 16.59375 11.285156 16.4375 10.75 16.15625 C 10.21875 15.875 9.824219 15.53125 9.5625 15.09375 C 9.300781 14.65625 9.117188 14.144531 9.0625 13.59375 C 9.007813 13.042969 9 12.503906 9 11.96875 L 9 3 Z M 6 21 L 6 23 L 20 23 L 20 21 Z"/>
            </svg>
        </button>

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code() }"
          @click="commands.code"
        >
          CC
        </button> -->

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.paragraph() }"
          @click="commands.paragraph"
        >
          T
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 1 }) }"
          @click="commands.heading({ level: 1 })"
        >
          H1
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 2 }) }"
          @click="commands.heading({ level: 2 })"
        >
          H2
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 3 }) }"
          @click="commands.heading({ level: 3 })"
        >
          H3
        </button>

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 4 }) }"
          @click="commands.heading({ level: 4 })"
        >
          H4
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 5 }) }"
          @click="commands.heading({ level: 5 })"
        >
          H5
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.heading({ level: 6 }) }"
          @click="commands.heading({ level: 6 })"
        >
          H6
        </button> -->

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
        >
          <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" class="vte-icon" 
            style="transform: scale(1);  margin-top: 4px; margin-left: 6px;">
                <path d="M 3 4.5 A 1.5 1.5 0 0 0 1.5 6 A 1.5 1.5 0 0 0 3 7.5 A 1.5 1.5 0 0 0 4.5 6 A 1.5 1.5 0 0 0 3 4.5 z M 7 5 L 7 7 L 22 7 L 22 5 L 7 5 z M 3 10.5 A 1.5 1.5 0 0 0 1.5 12 A 1.5 1.5 0 0 0 3 13.5 A 1.5 1.5 0 0 0 4.5 12 A 1.5 1.5 0 0 0 3 10.5 z M 7 11 L 7 13 L 22 13 L 22 11 L 7 11 z M 3 16.5 A 1.5 1.5 0 0 0 1.5 18 A 1.5 1.5 0 0 0 3 19.5 A 1.5 1.5 0 0 0 4.5 18 A 1.5 1.5 0 0 0 3 16.5 z M 7 17 L 7 19 L 22 19 L 22 17 L 7 17 z"/>
            </svg>
        </button>

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
        >
          <svg height="32" version="1.1" width="32" xmlns="http://www.w3.org/2000/svg" class="vte-icon" style="transform: scale(1);">
                <path d="M 2.8125 1 L 1.5 1.6875 C 1.398438 1.6875 1.304688 1.804688 1.40625 1.90625 L 1.59375 2.59375 C 1.492188 2.792969 1.585938 2.804688 1.6875 2.90625 L 1.90625 2.90625 L 2.5 2.59375 L 2.5 6.5 C 2.5 6.601563 2.585938 6.6875 2.6875 6.6875 L 3.6875 6.6875 C 3.789063 6.6875 3.90625 6.601563 3.90625 6.5 L 3.90625 1.3125 C 3.90625 1.113281 3.789063 1 3.6875 1 Z M 9 3 L 9 5 L 26 5 L 26 3 Z M 2.8125 10 C 2.113281 10 1.5 10.195313 1 10.59375 C 0.898438 10.695313 0.90625 10.804688 0.90625 10.90625 L 1.1875 11.59375 C 1.1875 11.695313 1.304688 11.6875 1.40625 11.6875 L 1.59375 11.6875 C 1.894531 11.386719 2.292969 11.3125 2.59375 11.3125 C 3.09375 11.3125 3.3125 11.507813 3.3125 11.90625 C 3.3125 12.507813 2.792969 12.988281 1.59375 14.1875 L 1 14.6875 L 1 15.5 C 1 15.601563 1.085938 15.6875 1.1875 15.6875 L 4.6875 15.6875 C 4.789063 15.6875 4.90625 15.601563 4.90625 15.5 L 4.90625 14.6875 C 5.007813 14.488281 4.886719 14.40625 4.6875 14.40625 L 3.1875 14.40625 C 3.988281 13.605469 4.8125 12.8125 4.8125 11.8125 C 4.8125 10.914063 4.210938 10 2.8125 10 Z M 9 12 L 9 14 L 26 14 L 26 12 Z M 2.8125 18.90625 C 2.113281 18.90625 1.488281 19.113281 1.1875 19.3125 C 1.085938 19.414063 1.09375 19.492188 1.09375 19.59375 L 1.3125 20.3125 C 1.3125 20.414063 1.398438 20.398438 1.5 20.5 L 1.6875 20.5 C 1.886719 20.398438 2.292969 20.1875 2.59375 20.1875 C 2.792969 20.1875 3.1875 20.292969 3.1875 20.59375 C 3.1875 20.992188 2.605469 21.09375 2.40625 21.09375 L 2 21.09375 C 1.898438 21.09375 1.8125 21.210938 1.8125 21.3125 L 1.8125 22 C 1.8125 22.101563 1.898438 22.1875 2 22.1875 L 2.40625 22.1875 C 2.605469 22.1875 3.3125 22.210938 3.3125 22.8125 C 3.3125 23.210938 3 23.40625 2.5 23.40625 C 2.101563 23.40625 1.605469 23.195313 1.40625 23.09375 L 1.1875 23.09375 C 1.085938 23.09375 1.09375 23.210938 1.09375 23.3125 L 0.90625 24 C 0.90625 24.101563 0.898438 24.210938 1 24.3125 C 1.300781 24.511719 1.894531 24.6875 2.59375 24.6875 C 4.195313 24.6875 4.90625 23.804688 4.90625 22.90625 C 4.90625 22.40625 4.59375 21.894531 4.09375 21.59375 C 4.492188 21.292969 4.6875 20.90625 4.6875 20.40625 C 4.6875 19.605469 4.113281 18.90625 2.8125 18.90625 Z M 9 21 L 9 23 L 26 23 L 26 21 Z"/>
            </svg>
        </button> -->

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.blockquote() }"
          @click="commands.blockquote"
        >
          II
        </button> -->

<!--         <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code_block() }"
          @click="commands.code_block"
        >
          db
        </button> -->

<!--         <button
          class="menubar__button"
          @click="commands.horizontal_rule"
        >
          HR
        </button> -->

<!--         <button
          class="menubar__button"
          @click="commands.undo"
        >
          Ud
        </button>

        <button
          class="menubar__button"
          @click="commands.redo"
        >
          Ub
        </button> -->

      </div>
    </EditorMenuBar>

    <EditorContent v-if="!(display && !editable)" class="editor__content" :editor="editor" />

    <label v-if="placeholder && placeholderVisible" class="vte-placeholder">{{ placeholder }}</label>

    <div v-if="display && !editable" class="vte-html" v-html="value">

    </div>

  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'

export default {
    name: 'vap-text-editor',
    components: {
        EditorContent, EditorMenuBar
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        editable: {
            type: Boolean,
            default: false
        },
        grouped: {
            type: Boolean,
            default: false
        },
        hideOnBlur: {
            type: Boolean,
            default: false
        },
        compact: {
            type: Boolean,
            default: false
        },
        display: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            hidden: false,
            placeholderVisible: true,
            editor: new Editor({
                editable: this.editable,
                extensions: [
                    new Blockquote(),
                    new BulletList(),
                    new CodeBlock(),
                    new HardBreak(),
                    new Heading({ levels: [1, 2, 3, 4, 5, 6] }),
                    new HorizontalRule(),
                    new ListItem(),
                    new OrderedList(),
                    new TodoItem(),
                    new TodoList(),
                    new Link(),
                    new Bold(),
                    new Code(),
                    new Italic(),
                    new Strike(),
                    new Underline(),
                    new History(),
                ],
                content: this.value,
                onUpdate: ( { state, getHTML, getJSON, transaction } ) => {
                    this.onInput();
                },
                onFocus: ({ event,  state, view }) => {
                    //if (this.hideOnBlur) this.hidden = false;
                },
                onBlur: ({ event,  state, view }) => {
                    //if (this.hideOnBlur) this.hidden = true;
                },
                onPaste: () => {
                    console.log(`New content was added from the user's clipboard!`)
                }
            })
        }
    },
    watch: {
        editable() {
            this.editor.setOptions({ editable: this.editable });
        },
        value() {
            this.editor.setContent(this.value);
        }
    },
    methods: {
        getText() {
          //console.log('text', this.editor.getHTML());
            return this.editor.getHTML();
        },
        checkPlaceholder() {
            if (this.editor.getHTML().length > 0 && this.editor.getHTML() != '<p></p>') {
                this.placeholderVisible = false;
            }else {
                this.placeholderVisible = true;
            }
        },
        onInput() {
            this.checkPlaceholder();
            this.$emit('updated', true);
        }
    },
    created() {
        this.checkPlaceholder();
        //if (this.hideOnBlur) this.hidden = true;
    },
    beforeDestroy() {
        this.editor.destroy()
    },
}
</script>

<style>

.vte-grouped {
    float: left;
    width: 100%;
}

.ProseMirror-focused {
    outline: none;
}

.vte-edit .ProseMirror {
    border-radius: 3px;
    border: solid 1px lightgray;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    min-height: 300px;
}
.vte-edit .ProseMirror-focused {
    border-radius: 3px;
    border: solid 1px gray;
    padding-left: 20px;
    padding-right: 20px;
}

.vte-grouped .ProseMirror {
    min-height: 150px;
}
.vte-compact .ProseMirror {
    min-height: 80px;
}

.editor__content p {
    margin: 0px;
}

.editor__content h2 {
    font-weight: normal;
}

.editor__content h6 {
    text-align: center;
}

.editor__content ul {
    margin-top: 0px;
}

.menubar {
    display: flex;
    margin-bottom: 10px;
}

.vte-hidden .menubar {
    visibility: hidden;
}

.vte-grouped .menubar {
    margin-bottom: 5px;
}

.menubar__button {
    border: none;
    position: relative;
    width: 38px;
    height: 32px;
    padding: 0px;
    padding-top: 1px;
    overflow: hidden;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
}
.menubar__button:hover {
    background-color: gray;
}

.menubar__button.is-active {
    background-color: lightgray;
}

.vte-icon {
    position: absolute;
    top: 0px;
    left: 0px;
}
.vte-icon path {
    fill: black;
}


.vte-placeholder {
    position: absolute;
    top: 58px;
    left: 28px;
    color: var(--input-placeholder);
}

</style>
